<!-- Chatbot Icon (Initially Visible) -->
<div class="chatbot-icon" *ngIf="!isOpen" (click)="toggleChat()">
  <mat-icon>chat</mat-icon>
</div>

<!-- Chatbot Window (Initially Hidden) -->
<div class="chatbot-container" [ngClass]="{'open': isOpen, 'close':!isOpen}">
  <div class="chatbot-header">
    <span>Chatbot</span>
    <mat-icon (click)="toggleChat()" >close</mat-icon>
  </div>

  <div class="chatbot-messages" #chatMessages>
    <div *ngFor="let message of messages" class="message-wrapper" [ngClass]="{'user-message': message.fromUser, 'bot-message': !message.fromUser}">
      <ng-container *ngIf="!message.fromUser">
        <mat-icon class="bot-icon">chat</mat-icon>
      </ng-container>
      <div class="message-text">{{ message.text }}</div>
    </div>

  </div>
  <div class="chatbot-input">
    <input matInput placeholder="How can I help you..." [(ngModel)]="userMessage" (keyup.enter)="sendMessage()">
    <button mat-icon-button color="primary" (click)="sendMessage()">
      <mat-icon>send</mat-icon>
    </button>
  </div>
</div>
